import React, { useCallback, useEffect, useState } from "react";
import { useAdminAuth } from "./AdminAuthContext";
import { useToast } from "./ToastProvider";
import { StatusPill, formatINR, fmtDate } from "./widgets";

export default function AdminInventory() {
  const { apiFetch } = useAdminAuth();
  const toast = useToast();
  const [list, setList] = useState([]);
  const [edits, setEdits] = useState({});

  const reload = useCallback(() => {
    apiFetch(`/admin/products`).then(({ data }) => {
      setList(data || []);
      setEdits({});
    }).catch(() => {});
  }, [apiFetch]);

  useEffect(() => { reload(); }, [reload]);

  const set = (id, v) => setEdits((e) => ({ ...e, [id]: v }));
  const save = async (id) => {
    const v = edits[id];
    if (v === undefined) return;
    try {
      await apiFetch(`/admin/products/${id}/stock`, {
        method: "PATCH",
        data: { stock_qty: Number(v) },
        headers: { "Content-Type": "application/json" },
      });
      toast("Stock updated");
      reload();
    } catch (e) {
      toast("Update failed", "err");
    }
  };
  const markOut = async (id) => { set(id, 0); await save(id); };

  return (
    <>
      <div className="adm-page-head">
        <div>
          <h1 className="adm-h1">Inventory</h1>
          <div className="adm-h1-sub">{list.length} SKUs</div>
        </div>
      </div>
      <div className="adm-card" style={{ padding: 0 }}>
        <table className="adm-table">
          <thead>
            <tr><th>Product</th><th>SKU</th><th>Status</th><th style={{ textAlign: "right" }}>Stock</th><th>Update</th><th></th></tr>
          </thead>
          <tbody>
            {list.map((p) => {
              const cur = edits[p.id] !== undefined ? edits[p.id] : p.stock_qty;
              const color = p.stock_qty === 0 ? "#EF4444" : p.stock_qty <= 5 ? "#F59E0B" : "#10B981";
              const lbl = p.stock_qty === 0 ? "OUT" : p.stock_qty <= 5 ? "LOW" : "OK";
              return (
                <tr key={p.id}>
                  <td><div className="adm-cell-name"><img src={p.images?.[0]} alt="" className="adm-thumb" /><div className="adm-cell-name-text"><span>{p.name}</span><span className="adm-cell-name-sub">{p.id}</span></div></div></td>
                  <td className="adm-mono" style={{ color: "#8B8B93" }}>{p.sku}</td>
                  <td><span className="adm-pill" style={{ color, borderColor: color + "33", background: color + "11" }}><span className="dot" style={{ background: color }} /> {lbl}</span></td>
                  <td className="adm-mono" style={{ textAlign: "right" }}>{p.stock_qty}</td>
                  <td><input className="adm-input adm-mono" style={{ width: 80, padding: "5px 8px" }} type="number" value={cur} onChange={(e) => set(p.id, e.target.value)} /></td>
                  <td style={{ display: "flex", gap: 6 }}>
                    <button className="adm-btn" style={{ padding: "5px 10px", fontSize: 12 }} onClick={() => save(p.id)} disabled={Number(cur) === p.stock_qty}>Save</button>
                    {p.stock_qty > 0 && <button className="adm-btn adm-btn-ghost" style={{ padding: "5px 10px", fontSize: 12 }} onClick={() => markOut(p.id)}>Mark out</button>}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
}
